import Schedules from "./Schedules";

function Content() {
    return (
        <Schedules />
    );
};

export default Content;